// This file is auto-generated by @hey-api/openapi-ts
/**
 * The transport protocol to use.
 */
export const PingProtocol = {
    ICMP: 'ICMP',
    TCP: 'TCP',
};
/**
 * EXPERIMENTAL: The IP version to use. Only allowed if the target is a hostname.
 *
 */
export const IpVersion = {
    4: 4,
    6: 6,
};
/**
 * The transport protocol to use.
 */
export const TracerouteProtocol = {
    ICMP: 'ICMP',
    TCP: 'TCP',
    UDP: 'UDP',
};
/**
 * The type of DNS query.
 */
export const DnsQueryType = {
    A: 'A',
    AAAA: 'AAAA',
    ANY: 'ANY',
    CNAME: 'CNAME',
    DNSKEY: 'DNSKEY',
    DS: 'DS',
    HTTPS: 'HTTPS',
    MX: 'MX',
    NS: 'NS',
    NSEC: 'NSEC',
    PTR: 'PTR',
    RRSIG: 'RRSIG',
    SOA: 'SOA',
    TXT: 'TXT',
    SRV: 'SRV',
    SVCB: 'SVCB',
};
/**
 * The protocol to use for the DNS query.
 */
export const DnsProtocol = {
    TCP: 'TCP',
    UDP: 'UDP',
};
/**
 * The transport protocol to use.
 */
export const MtrProtocol = {
    ICMP: 'ICMP',
    TCP: 'TCP',
    UDP: 'UDP',
};
/**
 * The HTTP method to use.
 */
export const HttpRequestMethod = {
    HEAD: 'HEAD',
    GET: 'GET',
    OPTIONS: 'OPTIONS',
};
export const HttpProtocol = {
    HTTP: 'HTTP',
    HTTPS: 'HTTPS',
    HTTP2: 'HTTP2',
};
/**
 * The measurement type.
 */
export const MeasurementType = {
    PING: 'ping',
    TRACEROUTE: 'traceroute',
    DNS: 'dns',
    MTR: 'mtr',
    HTTP: 'http',
};
/**
 * A two-letter continent code.
 */
export const ContinentCode = {
    AF: 'AF',
    AN: 'AN',
    AS: 'AS',
    EU: 'EU',
    NA: 'NA',
    OC: 'OC',
    SA: 'SA',
};
/**
 * A geographic region name based on UN [Standard Country or Area Codes for Statistical Use (M49)](https://unstats.un.org/unsd/methodology/m49/).
 *
 */
export const RegionName = {
    NORTHERN_AFRICA: 'Northern Africa',
    EASTERN_AFRICA: 'Eastern Africa',
    MIDDLE_AFRICA: 'Middle Africa',
    SOUTHERN_AFRICA: 'Southern Africa',
    WESTERN_AFRICA: 'Western Africa',
    CARIBBEAN: 'Caribbean',
    CENTRAL_AMERICA: 'Central America',
    SOUTH_AMERICA: 'South America',
    NORTHERN_AMERICA: 'Northern America',
    CENTRAL_ASIA: 'Central Asia',
    EASTERN_ASIA: 'Eastern Asia',
    SOUTH_EASTERN_ASIA: 'South-eastern Asia',
    SOUTHERN_ASIA: 'Southern Asia',
    WESTERN_ASIA: 'Western Asia',
    EASTERN_EUROPE: 'Eastern Europe',
    NORTHERN_EUROPE: 'Northern Europe',
    SOUTHERN_EUROPE: 'Southern Europe',
    WESTERN_EUROPE: 'Western Europe',
    AUSTRALIA_AND_NEW_ZEALAND: 'Australia and New Zealand',
    MELANESIA: 'Melanesia',
    MICRONESIA: 'Micronesia',
    POLYNESIA: 'Polynesia',
};
/**
 * The type of the used key, or `null` for unrecognized types.
 */
export const TlsKeyType = {
    RSA: 'RSA',
    EC: 'EC',
    NULL: 'null',
};
/**
 * The current measurement status. Any value other than `in-progress` is final.
 */
export const MeasurementStatus = {
    IN_PROGRESS: 'in-progress',
    FINISHED: 'finished',
};
/**
 * Type of the rate limit.
 */
export const RateLimitType = {
    IP: 'ip',
    USER: 'user',
};
//# sourceMappingURL=types.gen.js.map